import React, { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux';
import { resetRommingList } from '../../../store/slices/groupFiles/groupFilesSlice';
import { roomingList } from '../../../store/slices/groupFiles/thunks';
import { Control } from './Control';
import { RoomingTable } from './RoomingTable';
import { Summary } from './Summary';
import { WeedingPass } from './WeedingPass';
import { RoomCategoryControl } from './RoomCategoryControl';

export const Rooming = ({ groupFile }) => {
  const { roomingList:roomingList2 } = useSelector((state) => state.groupFiles);
  const dispatch = useDispatch();

  useEffect(() => {
    if (groupFile.id) {
      dispatch(roomingList(groupFile.id));
    }

    return () => {
      dispatch(resetRommingList());
    }
  }, [groupFile.id])


  return (
    <div>
      <RoomingTable />      
      <Control />

      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
        <WeedingPass weedingPass={roomingList2.weedingPass} message={groupFile.weedingPassMessage} />
        <RoomCategoryControl summaryByCategory={roomingList2.summaryByCategory} />
      </div>

      <Summary />

    </div>
  )
}
